import './TodayOffer.css';
import RightIcon from '../Images/Arrow_right.svg';
import Card from '../../Card';
import { Swiper, SwiperSlide } from "swiper/react";
import 'swiper/css/pagination';
import { Keyboard, Pagination, Navigation } from 'swiper/modules';
import TitleOfSection from '../TitleOfSection';
import { useEffect, useState } from 'react';
import { getproductsoffers } from '../../../network/api/product.js';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from "react-i18next";
const TodayOffer = ({id, update_p, personal}) => {
  const { t } = useTranslation();
  const[products,setProducts]=useState([]);
const navigate=useNavigate()
  useEffect(() => {
    getproductsoffers(id).then((results) => {
      setProducts(results?.data);
   
    });
  }, [id]);
  return (
    products.length > 0 &&(
    <div className='mt-4'>
      <div className='container mb-2' style={{direction:'rtl'}}>
        <div className="d-flex justify-content-between align-items-center">
          <TitleOfSection title={t("todaysOffers")} />
          <div  onClick={() => navigate(`/offersproducts/${id}/1`)}  className="" style={{ cursor: 'pointer' }}>
          {t("viewAll")}
            <img src={RightIcon} alt="icon" />
          </div>
        </div>
      </div>
      <div className="container" style={{direction:'rtl'}}>
        <Swiper
          slidesPerView={1.5}
          spaceBetween={10}
          breakpoints={{
            500: {
              slidesPerView: 2,
              spaceBetween: 15,
            },
            640: {
              slidesPerView: 2.2,
              spaceBetween: 20,
            },
            768: {
              slidesPerView: 2.8,
              spaceBetween: 15,
            },
            880: {
              slidesPerView: 3,
              spaceBetween: 20,
            },
            992: {
              slidesPerView: 3.5,
              spaceBetween: 20,
            },
            1200: {
              slidesPerView: 4,
              spaceBetween: 20,
            },
            1300: {
              slidesPerView: 4.3,
              spaceBetween: 20,
            },
            1400: {
              slidesPerView: 5,
              spaceBetween: 20,
            },
          }}
          navigation={true}
          modules={[Keyboard, Pagination, Navigation]}
          className="mySwiper mx-1"
        >
          {/* <SwiperSlide className='d-flex flex-column justify-content-center  gap-3 '>
            <Card />
          </SwiperSlide>
          <SwiperSlide className='d-flex flex-column justify-content-center  gap-3 '>
            <Card />
          </SwiperSlide>
          <SwiperSlide className='d-flex flex-column justify-content-center  gap-3 '>
            <Card />
          </SwiperSlide>
          <SwiperSlide className='d-flex flex-column justify-content-center  gap-3 '>
            <Card />
          </SwiperSlide>
          <SwiperSlide className='d-flex flex-column justify-content-center  gap-3 '>
            <Card />
          </SwiperSlide>
          <SwiperSlide className='d-flex flex-column justify-content-center  gap-3 '>
            <Card />
          </SwiperSlide>
          <SwiperSlide className='d-flex flex-column justify-content-center  gap-3 '>
            <Card />
          </SwiperSlide>
          <SwiperSlide className='d-flex flex-column justify-content-center  gap-3 '>
            <Card />
          </SwiperSlide>
          <SwiperSlide className='d-flex flex-column justify-content-center  gap-3 '>
            <Card />
          </SwiperSlide>
          <SwiperSlide className='d-flex flex-column justify-content-center  gap-3 '>
            <Card />
          </SwiperSlide> */}
           {products?.map((product, index) => (
            <SwiperSlide key={index} className='d-flex flex-column justify-content-center gap-3'>
               <Card
                    ImageCard={product.images[0].secure_url}
                    personal={personal}
                    update_p={update_p}
                    brand={product.brand}
                    name={product.name}
                    price={product.price_after}
                    id={product._id}
                    rate={product.averageRating ? product.averageRating : 0}
                    price_after={product.price_after}
                    price_before={product.price_before}
                    product={product}
                    
                  />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  )
  )
}

export default TodayOffer